<ng-container *ngIf="isNotSupported; else elseBlock">
  <h1>{{ficheDescriptiveOptions.title}}</h1>
  <div>Cette couche provient d'une organisation externe qui ne permet pas son interrogation</div>
</ng-container>
<ng-template #elseBlock>
  <ng-container *ngIf="isThereSomethingToDisplay; else noDataBlock">
    <h1>{{ficheDescriptiveOptions.title}}</h1>
    <h3 *ngIf="store.count>=100">{{ messageApplication.avertissement }}</h3>
    <igo-entity-table [template]="tableTemplate"
      [store]="store">
    </igo-entity-table>
    <div class="alert alert-warning"
      role="alert"
      *ngIf="isIncompleteList">Liste incomplète: {{numberReturned}} <span *ngIf="totalFeatures > 0"> de
        {{totalFeatures}}</span> affichés</div>
    <br />
  </ng-container>
</ng-template>
<ng-template #noDataBlock>
  <h1>{{ficheDescriptiveOptions.title}}</h1>
  <div>Aucune donnée retournée</div>
  <br />
</ng-template>